import { mutatorAction } from 'satcheljs';
import { getDiagnosticsLogState } from '../store/store';

export default mutatorAction('setSessionDetails', function setSelectedPivot(
    sessionDetails: string
) {
    getDiagnosticsLogState().sessionDetails = sessionDetails;
});
